import {
  Field,
  makeStyles,
  SpinButton,
  Switch,
  tokens,
} from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import { ImageEdit, Section, SectionColumn } from '@powerportalspro/react-fluent';
import { useState } from 'react';

// Localization namespace — reuses the Blazor demo's
// `ImageEditPropertiesDemo` keys so both stacks read from the same JSON.
const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Editors.ImageEdit.ImageEditPropertiesDemo';

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: tokens.spacingHorizontalL,
  },
  inlineField: {
    flexShrink: 0,
    gridTemplateColumns: 'auto auto',
    '& label': {
      whiteSpace: 'nowrap',
    },
  },
  numberInput: {
    width: '110px',
  },
});

export function ImageEditPropertiesSample() {
  const styles = useStyles();
  const t = useT();
  const [readOnly, setReadOnly] = useState(false);
  const [required, setRequired] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [displayImage, setDisplayImage] = useState(true);
  const [maxFileSizeBytes, setMaxFileSizeBytes] = useState(10 * 1024);

  return (
    <Section>
      <SectionColumn
        header={
          <div className={styles.toolbar}>
            <Switch
              label={t(`${STRINGS_BASE}.readonly`)}
              labelPosition="before"
              checked={readOnly}
              onChange={(_, d) => setReadOnly(d.checked)}
            />
            <Switch
              label={t(`${STRINGS_BASE}.required`)}
              labelPosition="before"
              checked={required}
              onChange={(_, d) => setRequired(d.checked)}
            />
            <Switch
              label={t(`${STRINGS_BASE}.disabled`)}
              labelPosition="before"
              checked={disabled}
              onChange={(_, d) => setDisabled(d.checked)}
            />
            <Switch
              label={t(`${STRINGS_BASE}.display-image`)}
              labelPosition="before"
              checked={displayImage}
              onChange={(_, d) => setDisplayImage(d.checked)}
            />
            <Field
              label={t(`${STRINGS_BASE}.max-file-size`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <SpinButton
                className={styles.numberInput}
                min={0}
                step={10000}
                value={maxFileSizeBytes}
                onChange={(_, d) => {
                  // Accept both the parsed numeric value (from +/-, blur,
                  // Enter) and the live displayValue (per-keystroke) so
                  // typing updates state immediately.
                  const n = typeof d.value === 'number' ? d.value : Number(d.displayValue);
                  if (Number.isFinite(n)) setMaxFileSizeBytes(n);
                }}
              />
            </Field>
          </div>
        }
      >
        <div style={{ maxWidth: '320px' }}>
          <ImageEdit
            columnName="ppp_primaryimage"
            required={required}
            readOnly={readOnly}
            disabled={disabled}
            displayImage={displayImage}
            maxFileSizeBytes={maxFileSizeBytes}
          />
        </div>
      </SectionColumn>
    </Section>
  );
}
